// extracted by mini-css-extract-plugin
module.exports = {"container":"e_VD","tagList":"e_WD","tag":"e_XD"};